import React, { Component } from 'react';

import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import PrimaryButton from "../Components/PrimaryButton";
import ThemePicker from "../Containers/ThemePicker";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import ParagraphText from "../Components/ParagraphText";
import TopContent from "../Components/TopContent";

class ThemePickerPage extends Component {
  componentDidMount() {
    if(this.props.wallet.address) {
      return this.props.history.push('/verify');
    }
  }
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <div className="spacer-40px" />
            <Centered>
              <TitleText>Theme</TitleText>
              <div className="spacer-20px" />
              <ParagraphText>Choose a theme for your gift:</ParagraphText>

              <ThemePicker/>

              <PrimaryButton to="/personalize" styles={'align-self: center;'}>Your note →</PrimaryButton>
              <div className="spacer-40px"/>
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  wallet: state.wallet
});

export default connect(mapStateToProps)(withRouter(ThemePickerPage));


// WEBPACK FOOTER //
// ./src/Pages/ThemePickerPage.js